<template>
  <div>
    <v-app-bar id="topBar" fixed dense elevation="3" color="white">
      <router-link to="/" data-cy="home-btn" style="margin: 10px">
        <img
          :src="require('@/assets/img/IMDC_noname.png')"
          height="30"
          :title="version"
        />

        <!-- <v-btn icon bottom v-on="on" style="text-decoration: none;" :title="version"> -->
        <!-- <v-icon style="width:50px; height:35px; text-decoration: none;">$custom</v-icon> -->
        <!-- </v-btn> -->
      </router-link>
      <Keypress
        key-event="keyup"
        :key-code="72"
        :modifiers="['altKey']"
        @success="$router.push({ name: 'appView' })"
      ></Keypress>
      <Keypress
        v-if="$route.params.id"
        key-event="keyup"
        :key-code="67"
        :modifiers="['altKey']"
        @success="$router.replace({ path: `/config/${$route.params.id}` })"
      ></Keypress>
      <Keypress
        v-if="$route.params.id"
        key-event="keyup"
        :key-code="77"
        :modifiers="['altKey']"
        @success="$router.replace({ path: `/map/${$route.params.id}` })"
      ></Keypress>
      <v-divider v-if="tractebelShow" class="mx-4" inset vertical></v-divider>
      <img
        v-if="tractebelShow"
        :src="require('@/assets/img/TRACTEBEL.jpg')"
        height="30"
        style="margin: 10px"
        :title="version"
      />
      <v-toolbar-title>Sinapps {{ manage(config.title) }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <template v-if="config.meetnet && $route.params.id && !$route.fullPath.includes('meetnet')">
        <v-btn color="grey darken-2" text @click="$router.push({ path: `/meetnet/${$route.params.id}/` })">
          meetnet<v-icon>mdi-clipboard-list-outline</v-icon>
        </v-btn>
      </template>

      <template v-else-if="$route.params.id && $route.fullPath.includes('meetnet')">
        <v-btn color="grey darken-2" text @click="$router.push({ path: `/map/${$route.params.id}` })">
          Map<v-icon>mdi-map</v-icon>
        </v-btn>
      </template>

      <!-- <v-btn icon bottom>
        <v-icon style="color:rgb(235, 88, 52)" @click="share">mdi-share-variant</v-icon>
      </v-btn>-->

      <v-menu
        bottom
        open-on-hover
        :close-delay="80"
        :offset-y="true"
        transition="scroll-y-reverse-transition"
        v-if="isAuthenticated"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon bottom v-on="on">
            <v-icon style="color: rgb(18, 219, 155)">mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <v-list-item-group color="primary">
          <v-list dense>
            <!-- <v-list-item v-for="(option, i) in userOptions" :key="i">
                          <v-list-item-content>{{ $t('common.' + option) }}</v-list-item-content>
            </v-list-item>-->
            <v-list-item>{{ $t("other.My Apps") }}</v-list-item>
            <v-list-item @click="showLoc" v-if="showLocationIfMap"
              ><v-switch
                dense
                @click.stop
                v-model="locationToggle"
                :label="$t('location')"
              ></v-switch
            ></v-list-item>
            <v-list-item @click="logout()">{{
              $t("common.Logout")
            }}</v-list-item>
            <v-list-item @click="changePasswordToggle = true"
              >Change Password</v-list-item
            >
          </v-list>
        </v-list-item-group>
      </v-menu>

      <v-menu
        bottom
        left
        open-on-hover
        :close-delay="80"
        :offset-y="true"
        transition="scroll-y-reverse-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon bottom v-on="on" data-cy="lang-btn">
            <v-icon style="color: rgb(18, 155, 219)">mdi-flag</v-icon>
          </v-btn>
        </template>
        <v-list-item-group color="primary">
          <v-list>
            <v-list-item v-for="(lang, i) in languages" :key="i">
              <v-list-item-content small depressed @click="setLanguage(lang)">{{
                lang
              }}</v-list-item-content>
            </v-list-item>
          </v-list>
        </v-list-item-group>
      </v-menu>
    </v-app-bar>
    <v-dialog v-model="changePasswordToggle" width="400">
      <v-card
        ><v-card-title class="text-h5 primary lighten-2"
          >Change password for user {{ userData.username }}</v-card-title
        >
        <v-card-text>
          <v-form
            @submit.prevent="
              $refs.passwordForm.validate() && passwordChangeSubmit()
            "
            ref="passwordForm"
          >
            <v-text-field
              type="password"
              :label="$t('old-password')"
              v-model="passwordDict.old_password"
              autofocus
            >
            </v-text-field>
            <v-text-field
              type="password"
              :label="$t('new-password')"
              v-model="passwordDict.new_password"
              :rules="[(x) => x.length >= 8 || 'minimum length 8 characters']"
            >
            </v-text-field>
            <v-text-field
              type="password"
              :label="$t('new-password') + ' (check)'"
              :rules="[
                (x) =>
                  x === passwordDict.new_password || `Passwords don't match`,
              ]"
            >
            </v-text-field>
            <v-btn
              type="submit"
              class="primary"
              :loading="passwordChangeLoading"
              >{{ $t("change-password") }}</v-btn
            >
            <v-spacer></v-spacer>
            <v-fade-transition>
              <v-alert
                border="left"
                color="red lighten-2"
                v-if="passwordChangeErrorMsg"
                >{{ passwordChangeErrorMsg }}</v-alert
              >
            </v-fade-transition>
          </v-form>
        </v-card-text></v-card
      >
    </v-dialog>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters } from "vuex";
import alertify from "alertify.js";
import "alertify.js/dist/css/alertify.css";
import { getToken } from "@/api";
import axios from "axios";
export default {
  data: () => ({
    locationToggle: false,
    changePasswordToggle: false,
    passwordChangeErrorMsg: undefined,
    passwordChangeLoading: false,
    watchId: undefined,
    languages: ["NL", "EN", "FR", "DE", "ES"],
    userOptions: ["Profile", "Logout"],
    name: undefined,
    on: undefined,
    passwordDict: { old_password: "", new_password: "" },
    svgPath: "../assets/circuit.svg",
    dialogShare: false,
    shareUrl: "",
    locLayer: undefined,
  }),
  mounted() {
    console.log("route", this.$route)
  },
  methods: {
    ...mapMutations(["setLanguage"]),
    async passwordChangeSubmit() {
      let token = getToken();
      this.passwordChangeLoading = true;
      try {
        await axios.put(
          `${process.env.VUE_APP_CAS_URL}/change_password`,
          this.passwordDict,
          { headers: { Authorization: `JWT ${token}` } }
        );
        this.changePasswordToggle = false;
        this.passwordDict = {
          old_password: "",
          new_password: "",
        };
      } catch (err) {
        this.passwordChangeErrorMsg = err.response.data || err;
      }
      this.passwordChangeLoading = false;
    },
    showLoc() {
      this.locLayer = this.$L.layerGroup([]);
      localStorage.setItem("synapps_loc", true);
      this.locLayer.addTo(this.map);
      this.watchId = navigator.geolocation.watchPosition(
        ({ coords }) => {
          try {
            this.locLayer.clearLayers();
          } catch (err) {}
          this.locLayer.addLayer(
            this.$L.circleMarker([coords.latitude, coords.longitude], {
              fillColor: "lightsteelblue",
              color: "darkblue",
              radius: 5,
              fillOpacity: 1,
              opacity: 1,
            })
          );
        },
        () => {}
      );
    },
    removeLoc() {
      localStorage.removeItem("synapps_loc");
      try {
        this.locLayer.clearLayers();
      } catch (err) {}
      navigator.geolocation.clearWatch(this.watchId);
    },
    manage(name) {
      return this.$route.name == "loginView"
        ? ""
        : "- " + (this.$_.isEmpty(name) ? this.$t("other.App overview") : name);
    },
    logout() {
      this.$store.commit("clearToken");
      // window.location.href = process.env.VUE_APP_CAS_URL + "/logout";
    },
  },
  computed: {
    ...mapState(["config", "map", "userData"]),
    ...mapGetters(["isAuthenticated"]),
    currentRoute() {
      if (this.$route.path.includes("map")) {
        return "map";
      } else if (this.$route.path.includes("config")) {
        return "config";
      } else {
        return "app";
      }
    },
    showLocationIfMap() {
      return this.$route.path.includes("map");
    },
    version() {
      return process.env.VUE_APP_VERSION;
    },
    tractebelShow() {
      if (
        this.config.title &&
        this.config.title.toLowerCase().includes("tractebel")
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    passwordChangeErrorMsg(newval) {
      if (newval) {
        setTimeout(() => {
          this.passwordChangeErrorMsg = undefined;
        }, 5000);
      }
    },
    locationToggle(newval) {
      if (newval) {
        console.log("showing loc");
        this.showLoc();
      } else {
        console.log("removing loc");
        this.removeLoc();
      }
    },
  },
  mounted() {
    if (localStorage.getItem("synapps_loc") == "true") {
      setTimeout(() => {
        this.locationToggle = true;
      }, 500);
    }
  },
};
</script>

<style>
#topBar {
  z-index: 10;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
